import { render, staticRenderFns } from "./SwitchIcon.vue?vue&type=template&id=2e7f9989&scoped=true&"
import script from "./SwitchIcon.vue?vue&type=script&lang=js&"
export * from "./SwitchIcon.vue?vue&type=script&lang=js&"
import style0 from "./SwitchIcon.vue?vue&type=style&index=0&id=2e7f9989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7f9989",
  null
  
)

export default component.exports